import React from 'react';
import WorkspaceModal from './WorkspaceModal';
import ManageWorkspacesModal from './ManageWorkspacesModal';

/** The sidebar's workspace modals — New workspace and Manage workspaces (card 5.2). */
export default function WorkspaceDialogs({ controls }) {
  const { dialog, setDialog, atLimit, create, workspaces } = controls;
  if (dialog === 'new') {
    return <WorkspaceModal atLimit={atLimit} onSubmit={create} onClose={() => setDialog(null)} />;
  }
  if (dialog === 'manage') {
    return <ManageWorkspacesModal workspaces={workspaces} onClose={() => setDialog(null)} />;
  }
  return null;
}
